module.exports = __webpack_public_path__ + "scatter.03161463.png";


//////////////////
// WEBPACK FOOTER
// ./src/db/img/scatter.png
// module id = dgEe
// module chunks = 1